{
    "GenericScopeTab_CME": "CME",
    "GenericScopeTab_Telsys": "Telefonieserver",
    "GenericScopeTab_Telsys_Required": "Telefonieserver ist erforderlich",
    "GenericScopeTab_Partition": "Partition",
    "GenericScopeTab_Device": "Gerät",
    "GenericScopeTab_FilterRecursive": "Rekursiv filtern",
    "NAME": "GenericScopeTab"
}